import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import type { GolfEventSummary } from '../types/api.types';

interface TourOverviewProps {
  lstEvents: GolfEventSummary[];
}

export default function TourOverview({ lstEvents }: TourOverviewProps) {
  if (lstEvents == null) {
    return <p>No Data</p>;
  }

  const eventRows = lstEvents.map((event) => (
    <tr key={event.id}>
      <td style={{ verticalAlign: 'middle' }}>
        <Link to={`/other-comps/${event.indCompID}`}>
          {event.date ? `${DateTime.fromISO(event.date).year} ${event.series || ''}` : event.series || ''}
        </Link>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{event.venueName}</td>
      <td style={{ verticalAlign: 'middle', padding: '1px' }}>
        <Link to={`/members/${event.indWinnerID}`}>
          <img src={`/assets/${event.indWinnerID}.jpg`} height="45px" alt="" />
          <span>{` ${event.indWinnerFirstName || ''} ${event.indWinnerSurname || ''}`}</span>
        </Link>
      </td>
    </tr>
  ));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Competition</th>
          <th>Venue</th>
          <th>Winner</th>
        </tr>
      </thead>
      <tbody>{eventRows}</tbody>
    </table>
  );
}
